module.exports = __webpack_public_path__ + "img/envelope.36e87fd8.jpg";